export default __webpack_public_path__ + "static/media/kotlin.288d3246.svg";